import React from 'react';
import { IIconProps } from './utils';

export const ReadingLevel = ({
  fill = 'currentColor', height = 22, width = 17, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 17 22"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_4720_6384)">
      <path
        d="M3.91663 3.0835H2.24996C1.79163 3.0835 1.41663 3.4585 1.41663 3.91683V19.7502C1.41663 20.2077 1.79163 20.5835 2.24996 20.5835H3.91663"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        clipRule="evenodd"
        d="M13.9166 9.75008L12.2499 8.08342L10.5833 9.75008V1.41675H13.9166V9.75008Z"
        fillRule="evenodd"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9166 3.0835H16.4166V20.5835H3.91663V3.0835H10.5833"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4720_6384">
        <rect
          fill="white"
          height={height}
          width={width}
        />
      </clipPath>
    </defs>
  </svg>
);
